import {useMutation, useQuery} from '@tanstack/react-query'

import {cacheKeys} from 'api'
import {TokenInfo} from 'constData'

import useApi from '../api/useApi'

import useProfile from './useProfile'

export default function useAssetQuery(asset) {
  const api = useApi()
  const {profile} = useProfile()

  const assetQuery = useQuery([cacheKeys.asset, asset], () => {
    if (!profile) return null
    if ([TokenInfo.V999.apiId, TokenInfo.GNS.apiId].includes(asset)) return null
    return api.getAsset({asset})
  })

  const refetchWithTimeout = useMutation(async ({timeout = 1500, initialFetch = true} = {}) => {
    if (initialFetch) {
      await assetQuery.refetch()
    }
    await new Promise(r => setTimeout(r, timeout))
    await assetQuery.refetch()
  })

  return {
    ...assetQuery,
    refetchWithTimeout,
  }
}
